import { render, staticRenderFns } from "./FormRatesMatrix.vue?vue&type=template&id=5a1c78a1&scoped=true&"
import script from "./FormRatesMatrix.vue?vue&type=script&lang=js&"
export * from "./FormRatesMatrix.vue?vue&type=script&lang=js&"
import style0 from "./FormRatesMatrix.vue?vue&type=style&index=0&id=5a1c78a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1c78a1",
  null
  
)

export default component.exports